import { TranslationWidth } from '@angular/common';
import { Injectable } from '@angular/core';
import { NgbDatepickerI18n, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { unreachable, _ } from './utils';

@Injectable()
export class DatepickerI18n extends NgbDatepickerI18n {
  constructor(private translate: TranslateService) {
    super();
  }

  getWeekdayLabel(weekday: number, width?: TranslationWidth): string {
    if (width == null) {
      width = TranslationWidth.Short;
    }
    switch (width) {
      case TranslationWidth.Narrow:
      case TranslationWidth.Short:
        return this.translate.instant([
          _('Mo'),
          _('Tu'),
          _('We'),
          _('Th'),
          _('Fr'),
          _('Sa'),
          _('Su'),
        ][weekday - 1]);
        case TranslationWidth.Abbreviated:
          return this.translate.instant([
            _('Mon'),
            _('Tue'),
            _('Wed'),
            _('Thu'),
            _('Fri'),
            _('Sat'),
            _('Sun'),
          ][weekday - 1]);
        case TranslationWidth.Wide:
          return this.translate.instant([
            _('Monday'),
            _('Tuesday'),
            _('Wednesday'),
            _('Thursday'),
            _('Friday'),
            _('Saturday'),
            _('Sunday'),
          ][weekday - 1]);
        default:
          unreachable(width);
    }
  }

  getMonthShortName(month: number, year?: number): string {
    return this.translate.instant([
      _('Jan'),
      _('Feb'),
      _('Mar'),
      _('Apr'),
      _('May'),
      _('Jun'),
      _('Jul'),
      _('Aug'),
      _('Sep'),
      _('Oct'),
      _('Nov'),
      _('Dec'),
    ][month - 1]);
  }

  getMonthFullName(month: number, year?: number): string {
    return this.translate.instant([
      _('January'),
      _('February'),
      _('March'),
      _('April'),
      // TODO: fix this ugly hack to get a separate translation for the long form
      _('May '),
      _('June'),
      _('July'),
      _('August'),
      _('September'),
      _('October'),
      _('November'),
      _('December'),
    ][month - 1]).trim();
  }

  // TODO: localize
  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}.${date.month}.${date.year}`;
  }
}
